export const addresses = {
  providerAddress: "0x1E93414cf36659084963E66c7cD24bDd00a55917",
};
